<div role="document">
  <div>
    <h2 id="prep-file-heading">Mise à jour Commerce</h2>
  </div>

  <div class=" justify-content-center">
    <form name="editForm" role="form" novalidate (ngSubmit)="f.form.valid && save()" [formGroup]="commercesCreateForm"
      #f="ngForm">
        <fieldset class="border p-2">
          <legend class="w-auto">Commerce</legend>
          <div class="form-row mb-2">
            <div class="col-4">
              <label for="companyName">Nom</label>

              <input type="text" class="form-control" id="companyName" name="companyName" [ngClass]="{ 'forminput-invalid':
              f.submitted && commercesCreateForm?.controls?.companyName?.errors != null}" formControlName="companyName"/>
              <div *ngIf="f.submitted && commercesCreateForm?.controls?.companyName?.errors" class="text-danger">
                champ Obligatoire
              </div>
            </div>
            <div class="col-6">
              <label class="form-control-label" for="adresse">Adresse : </label>
             <app-adresse (setAddress)="getAddress($event)" [autocompleteInput]="this.initialAdress" adressType="geocode" ></app-adresse>
            </div>
          </div>
          <div class="form-row mb-2">
            <div class="col-4">
              <label for="siret">Siret</label>

              <input type="text" class="form-control" id="siret" name="siret" [ngClass]="{ 'forminput-invalid':
              f.submitted && commercesCreateForm?.controls?.siret?.errors != null}" formControlName="siret"  maxlength="14" minlength="14"
              pattern="^[0-9]*$"/>
              <div *ngIf="f.submitted && commercesCreateForm?.controls?.siret?.errors" class="text-danger">
                champ Obligatoire
              </div>
            </div>
          </div>
      </fieldset>
      <fieldset class="border p-2">
        <legend class="w-auto">Contact</legend>
        <div class="form-row mb-2">
          <div class="col-2">
            <label class="form-control-label"  for="civilite">Civilité</label>
              <select class="custom-select" formControlName="civilite"
                [ngClass]="{ 'forminput-invalid':f.submitted && commercesCreateForm?.controls?.civilite?.errors != null}"
                 >
                <option value="" disabled>Choisissez une Valeur</option>
                <option *ngFor=" let genre of genres"
                [ngValue]="genre.code">
                  {{genre.code}}
                </option>
              </select>
            <div *ngIf="f.submitted && commercesCreateForm?.controls?.civilite?.errors"
             class="text-danger">
              champ Obligatoire
            </div>
          </div>
          <div class="col-4">
            <label for="contactName">Nom</label>

            <input type="text" class="form-control" id="contactName" name="contactName" [ngClass]="{ 'forminput-invalid':
            f.submitted && commercesCreateForm?.controls?.contactName?.errors != null}" formControlName="contactName"/>
            <div *ngIf="f.submitted && commercesCreateForm?.controls?.contactName?.errors" class="text-danger">
              champ Obligatoire
            </div>
          </div>
        </div>
        <div class="form-group row mb-2">
          <div class="col-6">
            <label class="form-control-label" for="email">Email : </label>
              <input type="text" class="form-control" formControlName="email"
              [ngClass]="{ 'forminput-invalid': f.submitted && commercesCreateForm?.controls?.email.errors }" />
            <div *ngIf="f.submitted && commercesCreateForm?.controls?.email?.errors?.required" class="text-danger">
              champ Obligatoire
            </div>
          </div>
        </div>
        <div class="form-group row mb-2">
          <div class="col-6">
            <label class="form-control-label" for="tel1">Téléphone 1: </label>
              <input type="text" class="form-control" id="tel1"
           name="tel1" formControlName="tel1" />
          </div>
        </div>
        <div class="form-group row mb-2">
          <div class="col-6">
            <label class="form-control-label" for="tel2">Téléphone 2: </label>
              <input type="text" class="form-control" id="tel2"
           name="tel1" formControlName="tel2" />
          </div>
        </div>

        </fieldset>
      <div class="m-2">
        <button type="button" id="cancel-save" class="btn btn-secondary" data-dismiss="modal"
          [routerLink]="['/commerces']">
          &nbsp;<span>Annuler</span>
        </button>
        &nbsp;&nbsp;
        <button type="submit" id="save-entity" class="btn btn-indigo">
          <span>Valider</span>
        </button>
      </div>
    </form>
  </div>
</div>
